// src/components/ui/index.tsx
/* Movatic WMS — UI stubs | CesarFilho 932048016
   Stubs mínimos e tipados para Button, Input, Label e Dialog*.
   Objetivo: compilar sem depender de shadcn/ui.
*/
import * as React from "react";

// ---------- Button ----------
export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    variant?: "default" | "outline" | "danger";
    size?: "sm" | "md" | "lg";
};
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    ({ variant = "default", size = "md", className = "", ...props }, ref) => {
        const v =
            variant === "outline"
                ? "border border-slate-600 bg-transparent"
                : variant === "danger"
                    ? "bg-red-600 hover:bg-red-700"
                    : "bg-blue-600 hover:bg-blue-700";
        const s =
            size === "sm"
                ? "px-2 py-1 text-sm"
                : size === "lg"
                    ? "px-5 py-3 text-base"
                    : "px-3 py-2 text-sm";
        return (
            <button
                ref={ref}
                className={`inline-flex items-center gap-2 rounded text-white ${v} ${s} ${className}`}
                {...props}
            />
        );
    }
);
Button.displayName = "Button";

// ---------- Input ----------
export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className = "", ...props }, ref) => (
        <input
            ref={ref}
            className={`w-full rounded border border-slate-600 bg-slate-900/40 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
            {...props}
        />
    )
);
Input.displayName = "Input";

// ---------- Label ----------
export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;
export const Label: React.FC<LabelProps> = ({ className = "", ...props }) => (
    <label className={`text-xs uppercase tracking-wide opacity-80 ${className}`} {...props} />
);

// ---------- Dialog (controlado e simples) ----------
type DialogProps = {
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
    children: React.ReactNode;
};
export const Dialog: React.FC<DialogProps> = ({ open = true, children }) =>
    open ? <div className="fixed inset-0 z-50 flex items-center justify-center">{children}</div> : null;

type BoxProps = React.HTMLAttributes<HTMLDivElement>;
export const DialogContent: React.FC<BoxProps> = ({ className = "", ...p }) => (
    <div
        className={`relative mx-4 max-h-[85vh] w-full max-w-xl overflow-auto rounded-lg border border-slate-700 bg-slate-900 p-4 shadow-xl ${className}`}
        {...p}
    />
);
export const DialogHeader: React.FC<BoxProps> = ({ className = "", ...p }) => (
    <div className={`mb-3 border-b border-slate-700 pb-2 ${className}`} {...p} />
);
export const DialogFooter: React.FC<BoxProps> = ({ className = "", ...p }) => (
    <div className={`mt-4 flex justify-end gap-2 ${className}`} {...p} />
);
export const DialogTitle: React.FC<React.HTMLAttributes<HTMLHeadingElement>> = ({
    className = "",
    ...p
}) => <h3 className={`text-base font-semibold ${className}`} {...p} />;
